import { CreateNewVenueModal } from "./CreateNewVenueModal";

export default CreateNewVenueModal;
